import NewFeatureEntity from "../entities/NewFeatureEntity";
import UserEntity from "../entities/UserEntity";

export default interface NewFeaturesRepository {
    featuresToShow(user: UserEntity): Promise<NewFeatureEntity[]>;
    dontShowAgain(user: UserEntity): Promise<void>;
    showLater(user: UserEntity): Promise<void>;
}

export const NewFeaturesRepositoryName = "NewFeaturesRepository";